import React from "react";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-img">
        <img alt="profile_pic" src="https://avatars.githubusercontent.com/u/106084566?v=4" />
      </div>

      <div className="about-text">
        <h2>About Me</h2>
        <h4>Hi,</h4>
        <p>
          
I am an experienced software engineer with a focus on web development and Android development. My goal is to broaden my expertise and skills in this field. I have a strong passion for Android development and backend development, with a particular emphasis on APIs, data science, and machine learning. I thoroughly enjoy working with multiple programming languages and I am enthusiastic about making contributions that drive the progress and improvement of existing and future systems.
        </p>
        <div
          className="contact-icons"
          style={{ marginTop: "-15px", marginBottom: "15px" }}
        >
          <a
            href="https://www.linkedin.com/in/v-ctor-kinoti-89128a242"
            target="blank"
          >
            <i className="bx bxl-linkedin"></i>
          </a>
          <a href="https://github.com/Karemu1842call" target="blank">
            <i className="bx bxl-github"></i>
          </a>
        </div>
       
    
      </div>
    </section>
  );
};

export default About;
